"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _append = _interopRequireDefault(require("./append"));
var _copy = _interopRequireDefault(require("../run/copy"));
var _insert = _interopRequireDefault(require("../run/insert"));
var _runIndexAt = _interopRequireDefault(require("./runIndexAt"));
var _stringFromCodePoints = _interopRequireDefault(require("../utils/stringFromCodePoints"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var mapCond = function mapCond(conds) {
  return R.addIndex(R.map)(R.cond(conds));
};
var idxEquals = function idxEquals(idx) {
  return R.compose(R.equals(idx), R.nthArg(1));
};
var idxGt = function idxGt(idx) {
  return R.compose(R.gt(R.__, idx), R.nthArg(1));
};

/**
 * Insert glyph into attributed string
 *
 * @param {number} index
 * @param {Object} glyph
 * @param {Object} attributed string
 * @return {Object} attributed string with new glyph
 */
var insertGlyph = function insertGlyph(index, glyph, string) {
  var runIndex = (0, _runIndexAt.default)(index, string);

  // Add glyph to the end if run index invalid
  if (runIndex === -1) {
    return (0, _append.default)(glyph, string);
  }
  var codePoints = R.propOr([], 'codePoints')(glyph);
  var incRange = R.add(R.length(codePoints));
  return R.evolve({
    string: R.compose(R.join(''), R.insert(index, (0, _stringFromCodePoints.default)(codePoints))),
    runs: mapCond([[idxEquals(runIndex), function (run) {
      return (0, _insert.default)(index - run.start, glyph, run);
    }], [idxGt(runIndex), R.evolve({
      start: incRange,
      end: incRange
    })], [R.T, _copy.default]])
  })(string);
};
var _default = exports.default = R.curryN(3, insertGlyph);